const translations = {
    create: 'create'
};

export default translations;
